import { PenaltyContent as PenaltyContentComponent } from './PenaltyContent.component';
import { connector } from './PenaltyContent.connector';

export const PenaltyContent = connector(PenaltyContentComponent);
